import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { DevExListBoxComponent } from '../../../devExtreme/src/devExListBox/devExListBox.component';
import { MatListBoxComponent } from '../../../material/src/matListBox/matListBox.component';
import { ComponentStyle } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import { AbcListBoxModel, ItemDeleteMode, SelectionModeList, ShowScrollbar, SreachModeList } from './abcListBox';

@Component({
    selector: 'abcListBox',
    template: '<ng-template  #abcListBox ></ng-template>',
    standalone: false
})
export class AbcListBoxComponent implements OnInit {
  @ViewChild('abcListBox', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Input() dataSource: any;
  @Input() keyExpr: any;
  @Input() selectedItems: any;
  @Input() checkboxes: any;
  @Input() showCheckBox: boolean;
  @Input() dynamicKey: string;
  @Input() showCommentsTemplate: boolean = false;
  @Input() showDxTemplate: boolean = false;
  @Input() showTemplateImage: boolean = false;
  @Output() onSelectionChanged = new EventEmitter();
  @Output() onItemClick = new EventEmitter();
  @Output() onItemDeleting = new EventEmitter();
  @Output() onContentReady = new EventEmitter();
  private _activeStateEnabled: boolean;
  private _allowItemDeleting: boolean;
  private _collapsibleGroups: boolean;
  private _focusStateEnabled: boolean;
  private _grouped: boolean;
  private _hoverStateEnabled: boolean;
  private _itemDeleteMode: ItemDeleteMode;
  private _height: string;
  private _width: string;
  private _disabled: boolean;
  private _visible: boolean = true;
  private _rtlEnabled: boolean;
  private _showSelectionControls: boolean;
  private _searchEnabled: boolean;
  private _selectionMode: SelectionModeList;
  private _scrollingEnabled: boolean;
  private _class: string;
  private _searchExpr: string;
  private _searchMode: SreachModeList;
  private _searchValue: string;
  private _showScrollbar: ShowScrollbar;
  private _itemTemplate: string;
  private _groupImages: any;
  private _source: any;

  @Input()
  get groupImages() {
    return this._groupImages;
  }
  set groupImages(data: string) {
    this._groupImages = data;
    if (this.componentRef) {
      this.componentRef.groupImages = data;
    }
  }

  @Input()
  get source() {
    return this._source;
  }
  set source(data: any) {
    this._source = data;
    if (this.componentRef) {
      this.componentRef.source = data;
    }
  }

  @Input()
  get height() {
    return this._height;
  }
  set height(data: string) {
    this._height = data;
    if (this.componentRef) {
      this.componentRef.height = data;
    }
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data: string) {
    this._width = data;
    if (this.componentRef) {
      this.componentRef.width = data;
    }
  }

  @Input()
  get itemTemplate() {
    return this._itemTemplate;
  }
  set itemTemplate(data: string) {
    this._itemTemplate = data;
    if (this.componentRef) {
      this.componentRef.itemTemplate = data;
    }
  }

  @Input()
  get searchValue() {
    return this._searchValue;
  }
  set searchValue(data: string) {
    this._searchValue = data;
    if (this.componentRef) {
      this.componentRef.searchValue = data;
    }
  }

  @Input()
  get showScrollbar() {
    return this._showScrollbar;
  }
  set showScrollbar(data: ShowScrollbar) {
    this._showScrollbar = data;
    if (this.componentRef) {
      this.componentRef.showScrollbar = data;
    }
  }

  @Input()
  get searchMode() {
    return this._searchMode;
  }
  set searchMode(data: SreachModeList) {
    this._searchMode = data;
    if (this.componentRef) {
      this.componentRef.searchMode = data;
    }
  }

  @Input()
  get searchExpr() {
    return this._searchExpr;
  }
  set searchExpr(data: string) {
    this._searchExpr = data;
    if (this.componentRef) {
      this.componentRef.searchExpr = data;
    }
  }

  @Input()
  get class() {
    return this._class;
  }
  set class(data: string) {
    this._class = data;
    if (this.componentRef) {
      this.componentRef.class = data;
    }
  }

  @Input()
  get scrollingEnabled() {
    return this._scrollingEnabled;
  }
  set scrollingEnabled(data: boolean) {
    this._scrollingEnabled = data;
    if (this.componentRef) {
      this.componentRef.scrollingEnabled = data;
    }
  }

  @Input()
  get visible() {
    return this._visible;
  }
  set visible(data: boolean) {
    this._visible = data;
    if (this.componentRef) {
      this.componentRef.visible = data;
    }
  }

  @Input()
  get searchEnabled() {
    return this._searchEnabled;
  }
  set searchEnabled(data: boolean) {
    this._searchEnabled = data;
    if (this.componentRef) {
      this.componentRef.searchEnabled = data;
    }
  }

  @Input()
  get selectionMode() {
    return this._selectionMode;
  }
  set selectionMode(data: SelectionModeList) {
    this._selectionMode = data;
    if (this.componentRef) {
      this.componentRef.selectionMode = data;
    }
  }

  @Input()
  get showSelectionControls() {
    return this._showSelectionControls;
  }
  set showSelectionControls(data: boolean) {
    this._showSelectionControls = data;
    if (this.componentRef) {
      this.componentRef.showSelectionControls = data;
    }
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data: boolean) {
    this._disabled = data;
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data: boolean) {
    this._rtlEnabled = data;
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
  }

  @Input()
  get allowItemDeleting() {
    return this._allowItemDeleting;
  }
  set allowItemDeleting(data: boolean) {
    this._allowItemDeleting = data;
    if (this.componentRef) {
      this.componentRef.allowItemDeleting = data;
    }
  }

  @Input()
  get activeStateEnabled() {
    return this._activeStateEnabled;
  }
  set activeStateEnabled(data: boolean) {
    this._activeStateEnabled = data;
    if (this.componentRef) {
      this.componentRef.activeStateEnabled = data;
    }
  }

  @Input()
  get focusStateEnabled() {
    return this._focusStateEnabled;
  }
  set focusStateEnabled(data: boolean) {
    this._focusStateEnabled = data;
    if (this.componentRef) {
      this.componentRef.focusStateEnabled = data;
    }
  }

  @Input()
  get collapsibleGroups() {
    return this._collapsibleGroups;
  }
  set collapsibleGroups(data: boolean) {
    this._collapsibleGroups = data;
    if (this.componentRef) {
      this.componentRef.collapsibleGroups = data;
    }
  }

  @Input()
  get itemDeleteMode() {
    return this._itemDeleteMode;
  }
  set itemDeleteMode(data: ItemDeleteMode) {
    this._itemDeleteMode = data;
    if (this.componentRef) {
      this.componentRef.itemDeleteMode = data;
    }
  }

  @Input()
  get hoverStateEnabled() {
    return this._hoverStateEnabled;
  }
  set hoverStateEnabled(data: boolean) {
    this._hoverStateEnabled = data;
    if (this.componentRef) {
      this.componentRef.hoverStateEnabled = data;
    }
  }

  @Input()
  get grouped() {
    return this._grouped;
  }
  set grouped(data: boolean) {
    this._grouped = data;
    if (this.componentRef) {
      this.componentRef.grouped = data;
    }
  }

  @Input() style: ComponentStyle = ComponentStyle.DevExpress;
  eventListener = [];
  public componentRef: any;

  constructor(private abcComponentService: AbcComponentService) {
    this.rtlEnabled = this.abcComponentService.rtlEnabled;
  }

  ngOnInit() {
    this.createComponentInstance().subscribe((component) => {
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  public createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.Material: {
          this.componentRef = this.abcComponentService.loadComponent(
            MatListBoxComponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.componentRef.source = this.source;
          break;
        }
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExListBoxComponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.componentRef.selectionMode = this.selectionMode;
          this.componentRef.groupImages = this.groupImages;
          this.componentRef.showCheckBox = this.showCheckBox;
          this.componentRef.searchEnabled = this.searchEnabled;
          this.componentRef.searchExpr = this.searchExpr;
          this.componentRef.searchMode = this.searchMode;
          this.componentRef.grouped = this.grouped;
          this.componentRef.allowItemDeleting = this.allowItemDeleting;
          this.componentRef.itemDeleteMode = this.itemDeleteMode;
          this.componentRef.showDxTemplate = this.showDxTemplate;
          this.componentRef.showTemplateImage = this.showTemplateImage;
          this.componentRef.showCommentsTemplate = this.showCommentsTemplate;
          this.componentRef.dynamicKey = this.dynamicKey;
          this.componentRef.collapsibleGroups = this.collapsibleGroups;
          this.componentRef.hoverStateEnabled = this.hoverStateEnabled;
          this.componentRef.activeStateEnabled = this.activeStateEnabled;
          this.componentRef.focusStateEnabled = this.focusStateEnabled;
          this.componentRef.disabled = this.disabled;
          this.componentRef.visible = this.visible;
          this.componentRef.scrollingEnabled = this.scrollingEnabled;
          this.componentRef.rtlEnabled = this.rtlEnabled ? this.rtlEnabled : false;
          this.componentRef.selectedItems = this.selectedItems;
          this.componentRef.keyExpr = this.keyExpr;
          this.componentRef.showSelectionControls = this.showSelectionControls;
          this.componentRef.searchValue = this.searchValue;
          this.componentRef.showScrollbar = this.showScrollbar;
          this.componentRef.class = this.class;
          this.componentRef.dataSource = this.dataSource;
          this.componentRef.width = this.width;
          this.componentRef.height = this.height;
          this.componentRef.checkboxes = this.checkboxes;
          this.componentRef.source = this.source;
          this.componentRef.onItemClick.subscribe((event) => {
            this.itemClick(event);
          });
          this.componentRef.onSelectionChanged.subscribe((event) => {
            this.selectionChanged(event);
          });
          this.componentRef.onItemDeleting.subscribe((event) => {
            this.itemDeleting(event);
          });
          this.componentRef.onContentReady.subscribe((event) => {
            this.onContentReady.emit(event);
          });
          break;
        }
      }
      observer.next(this.componentRef);
    });
    return observable;
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    this.eventListener.push({ type, listener });
  }

  getSelectedItem(): string {
    return this.componentRef.onSelect();
  }

  getcheckedItems(): AbcListBoxModel[] {
    let items = this.componentRef.checkChange();
    let checkedItems: AbcListBoxModel[] = [];
    this.componentRef.assignOpathToData(items);
    items.forEach((element) => {
      let checkedElement: AbcListBoxModel = new AbcListBoxModel();
      checkedElement.caption = element.label || element.text;
      checkedElement.name = element.group;
      checkedItems.push(checkedElement);
    });
    return checkedItems;
  }

  private itemClick(event: Event) {
    this.onItemClick.emit(event);
  }

  private selectionChanged(event: Event) {
    this.onSelectionChanged.emit(event);
  }

  private itemDeleting(event: Event) {
    this.onItemDeleting.emit(event);
  }

  public refresh(): void {
    this.componentRef?.refresh();
  }

  public unselectAll() {
    switch (this.style) {
      case ComponentStyle.DevExpress:
        if (this.componentRef) {
          this.componentRef.unselectAll();
        }
        break;
      default:
        break;
    }
  }
}
